/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum CandidateOppFeedAlertFrequency {
  Instant = "Instant",
  Daily = "Daily",
  Weekly = "Weekly",
}

export const CandidateOppFeedAlertFrequencyDisplay: Record<CandidateOppFeedAlertFrequency, string> = {
  [CandidateOppFeedAlertFrequency.Instant]: "Instant",
  [CandidateOppFeedAlertFrequency.Daily]: "Daily",
  [CandidateOppFeedAlertFrequency.Weekly]: "Weekly",
};
